// Методы для расчета сумм в таблицах BDR
export const bdrTableMethods = {
    data() {
        return {
            alertSumLine: '',
            alertOperationTable: [],
            alertOpen: false
        }
    },
    methods: {
        // сумма в каждой ячейке по месяцам
        calcMonthSum(operations, month) {
            let sum = [];
            if (operations) {
                operations.forEach(operation => {
                    if (operation.month === month) {
                        sum.push(operation.value)
                    }
                })
            }
            return sum.reduce((acc, current) => { return acc + current }, 0)
        },

        // собрать операции в каждой ячейке по месяцам
        calcMonthOperations(operations, month) {
            let takeOperations = [];
            let plusOperations = [];
            if (operations) {
                operations.forEach(operation => {
                    if (operation.month === month) {
                        takeOperations.push(operation)
                        plusOperations.push(operation.value)
                    }
                })
            }
            
            this.alertSumLine = plusOperations.join(' + ');
            this.alertOperationTable = takeOperations;
            this.alertOpen = true;
        },

        // сумма рядов
        calcRowSum(operations) {
            let sum = [];
            if (operations) {
                operations.forEach(operation => {
                    sum.push(operation.value)
                })
            }
            return sum.reduce((acc, current) => { return acc + current }, 0)
        },

        // сумма по столбцам
        calcColumnSum(children, month) {
            let sum = [];
            children.forEach(child => {
                if (child.operations) {
                    child.operations.forEach(operation => {
                        if (operation.month === month) {
                            sum.push(operation.value)
                        }
                    })
                }
            })
            return sum.reduce((acc, current) => { return acc + current }, 0)
        },

        // сумма всех ячеек
        calcAllSums(children) {
            let sum = [];
            children.forEach(child => {
                if (child.operations) {
                    child.operations.forEach(operation => {
                        sum.push(operation.value)
                    })
                }
            })
            return sum.reduce((acc, current) => { return acc + current }, 0)
        },

        // Маржинальная прибыль по месяцам
        calcMarginProfitMonth(profit, variableCost, month) {
            return this.calcColumnSum(profit, month) - this.calcColumnSum(variableCost, month);
        },

        // Вся маржинальная прибыль
        calcMarginProfitAll(profit, variableCost) {
            return this.calcAllSums(profit) - this.calcAllSums(variableCost);
        },

        // ПОСТОЯННЫЕ ЗАТРАТЫ
        // объединение в один объект всех child...........переделать с рекурсией
        allChildren(children) {
            let calcChildren = [];

            for (let i = 0; i < children.length; i++) {
                calcChildren.push(children[i])
                if (children[i].children.length) {
                    children[i].children.forEach(child => {
                        calcChildren.push(child)
                        if (child.children.length) {
                            child.children.forEach(subChild => calcChildren.push(subChild))
                        }
                    })
                }
            }
            return calcChildren;
        },

        // расчет суммы в пунктах по месяцам в Постоянные затраты
        calcSumSubPoints(child, month) {
            // если у child есть операции (12. или 5.1.1)
            if (child.operations) {
                return this.calcMonthSum(child.operations, month);
            } else { // если у child нет операций то есть children
                let sum = [];
                // для каждого подпункта в child
                child.children.forEach(subChild => {
                    // если есть операции у подпункта
                    if (subChild.operations) {
                        subChild.operations.forEach(operation => {
                            if (operation.month === month) {
                                sum.push(operation.value)
                            }
                        })
                    } else { // для каждого подподпункта в подпункте
                        subChild.children.forEach(subSubChild => {
                            if (subSubChild.operations) {
                                subSubChild.operations.forEach(operation => {
                                    if (operation.month === month) {
                                        sum.push(operation.value)
                                    }
                                })
                            }
                        })
                    }
                })
                return sum.reduce((acc, current) => { return acc + current }, 0);
            }
        },

        // расчет суммы рядов в Постоянные затраты
        calcSumWithSubRow(child) {
            if (child.operations && child.operations.length) {
                return this.calcRowSum(child.operations);
            } else {
                let sum = [];
                child.children.forEach(subChild => {
                    if (subChild.operations) {
                        subChild.operations.forEach(operation => {
                            sum.push(operation.value)
                        })
                    } else {
                        subChild.children.forEach(subSubChild => {
                            if (subSubChild.operations) {
                                subSubChild.operations.forEach(operation => {
                                    sum.push(operation.value)
                                })
                            }
                        })
                    }
                })
                return sum.reduce((acc, current) => { return acc + current }, 0);
            }
        },


        // собрать операции в каждой ячейке по месяцам с вложеними
        calcMonthOperationsWithSubRow(child, month) {
            let takeOperations = [];
            let plusOperations = [];

            if (child.operations && child.operations.length) {
                if (child.operations) {
                    child.operations.forEach(operation => {
                        if (operation.month === month) {
                            takeOperations.push(operation)
                            plusOperations.push(operation.value)
                        }
                    })
                }
            } else {
                if (child.children.length > 0) {
                    child.children.forEach(subChild => {
                        if (subChild.operations) {
                            subChild.operations.forEach(operation => {
                                takeOperations.push(operation)
                                plusOperations.push(operation.value)
                            })
                        } else {
                            subChild.children.forEach(subSubChild => {
                                if (subSubChild.operations) {
                                    subSubChild.operations.forEach(operation => {
                                        takeOperations.push(operation)
                                        plusOperations.push(operation.value)
                                    })
                                }
                            })
                        }
                    })
                }
            }
            
            this.alertSumLine = plusOperations.join(' + ');
            this.alertOperationTable = takeOperations;
            this.alertOpen = true;
        },

        // расчет суммы столбцов в Постоянные затраты
        calcSumSubCols(children, month) {
            let sum = [];
            children.forEach(child => {
                if (child.operations) {
                    child.operations.forEach(operation => {
                        if (operation.month === month) {
                            sum.push(operation.value)
                        }
                    })
                }
            })
            return sum.reduce((acc, current) => { return acc + current }, 0);
        },

        // сумма всех яцеек в Постоянные затраты
        calcAllSubSums(children) {
            let sum = [];
            children.forEach(child => {
                if (child.operations) {
                    child.operations.forEach(operation => {
                        sum.push(operation.value)
                    })
                }
            })
            return sum.reduce((acc, current) => { return acc + current }, 0);
        },

        // РАСЧЕТ ПРИБЫЛИ и ЧИСТОЙ ПРИБЫЛИ
        // прибыль по месяцам
        calcProfitCols(bdr, month) {
            return this.calcMarginProfitMonth(bdr[0].children[0].children, bdr[1].children[0].children, month) - this.calcSumSubCols(this.allChildren(bdr[2].children), month);
        },

        // вся прибыль
        calcAllProfit(bdr) {
            return this.calcMarginProfitAll(bdr[0].children[0].children, bdr[1].children[0].children) - this.calcAllSubSums(this.allChildren(bdr[2].children));
        },

        // чистая прибыль по месяцам
        calcNetProfitCols(bdr, month) {
            return this.calcProfitCols(bdr, month) - this.calcColumnSum(bdr[3].children, month);
        },

        // вся чистая прибыль
        calcAllNetProfit(bdr) {
            return this.calcAllProfit(bdr) - this.calcAllSums(bdr[3].children);
        }
    },
}

